import FooterBar from './FooterBar/FooterBar';
import { withTranslation } from 'react-i18next';

export default withTranslation("footer")(FooterBar);